export var HttpProtocol;
(function (HttpProtocol) {
    HttpProtocol["HTTP"] = "http";
    HttpProtocol["HTTPS"] = "https";
})(HttpProtocol || (HttpProtocol = {}));
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "get";
    HttpMethod["POST"] = "post";
})(HttpMethod || (HttpMethod = {}));
/**
 * Convert all fields in a payload dictionary to strings
 *
 * @param payload - Payload on which the new dictionary is based
 */
export const preparePayload = (payload) => {
    const stringifiedPayload = {};
    const finalPayload = addDeviceSentTimestamp(payload);
    for (const key in finalPayload) {
        if (Object.prototype.hasOwnProperty.call(finalPayload, key)) {
            stringifiedPayload[key] = String(finalPayload[key]);
        }
    }
    return stringifiedPayload;
};
/**
 * Adds the 'stm' paramater with the current time to the payload
 * @param payload - The payload which will be mutated
 */
const addDeviceSentTimestamp = (payload) => {
    payload["stm"] = new Date().getTime().toString();
    return payload;
};
